export default __webpack_public_path__ + "static/PROUD_2xl-174aaee55f831678f8a7e0a6506fe494.webp";